module.exports = __webpack_public_path__ + "img/流体力学3_2_1.cc36c947.jpg";